import { FC, useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { pendoTags } from '../../../../../constants/pendoTags';
import { useSteps } from '../../../../../hooks/useSteps';
import { useSendFormsContext } from '../../../../../providers/context';
import { finishSendFormTracking } from '../../../../../utils/tracker/tracker.utils';
import DeliveryOption from '../delivery-option/delivery-option.component';

const SendAsKioskQR: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { origin } = useSendFormsContext();
  const { goToNextStep } = useSteps();

  const sendToKioskHandler = useCallback(() => {
    finishSendFormTracking({
      isComplete: true,
      deliveryMethod: 'kiosk',
      origin,
    });
    goToNextStep();
  }, [origin, goToNextStep]);

  return (
    <DeliveryOption
      icon='kiosk-small'
      displayName={t('Send to Kiosk')}
      deliveryMethod='kiosk'
      onClick={sendToKioskHandler}
      trackingId={pendoTags.steps.deliveryMethod.kiosk.select}
    />
  );
};

export default SendAsKioskQR;
